<script setup lang="ts">
import type { PhxsgSlideProps as PhxsgCoreSlideProps } from '@sg-core/src/View/Components/Organisms/Slider';

import { PhxsgSlide } from '../Slider';

defineProps<PhxsgCoreSlideProps>();

defineOptions({
  name: 'SwiperSlide',
});
</script>

<template>
  <PhxsgSlide v-bind="$props">
    <div class="phxsg-product-card-slider__slide-wrapper">
      <slot />
    </div>
  </PhxsgSlide>
</template>
